namespace Matrix.Exceptions {
    export interface ExceptionRow {
        ExceptionSource?: string;
        ExceptionContext?: string;
        ExceptionContextIndex?: number;
        ExceptionSchema?: string;
        ExceptionTable?: string;
        ExceptionKey?: string;
        ExceptionTypeCode?: string;
        SeverityCode?: string;
        SeverityScore?: number;
        Description?: string;
        SystemTags?: string;
        Properties?: string;
        RowId?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        Version?: number;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IgnorePolicyCode?: string;
        Notes?: string;
        UserTags?: string;
        AssignedTo?: string;
        AssignedBy?: string;
        AssignedWhen?: string;
        ReviewedBy?: string;
        ReviewedWhen?: string;
        IgnoredBy?: string;
        IgnoredWhen?: string;
        IgnoredUntil?: string;
        CompletedBy?: string;
        CompletedWhen?: string;
        ExceptionTypeCodeDescription?: string;
        ExceptionTypeCodeRowId?: number;
        SeverityCodeSeverityLevel?: number;
        SeverityCodeRowId?: number;
        ExceptionLinks?: ExceptionLinkRow[];
    }

    export namespace ExceptionRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'ExceptionSource';
        export const localTextPrefix = 'Exceptions.Exception';
        export const deletePermission = 'DataAdmin:Exception';
        export const insertPermission = 'DataAdmin:Exception';
        export const readPermission = 'Read:Exception';
        export const updatePermission = 'DataAdmin:Exception';

        export declare const enum Fields {
            ExceptionSource = "ExceptionSource",
            ExceptionContext = "ExceptionContext",
            ExceptionContextIndex = "ExceptionContextIndex",
            ExceptionSchema = "ExceptionSchema",
            ExceptionTable = "ExceptionTable",
            ExceptionKey = "ExceptionKey",
            ExceptionTypeCode = "ExceptionTypeCode",
            SeverityCode = "SeverityCode",
            SeverityScore = "SeverityScore",
            Description = "Description",
            SystemTags = "SystemTags",
            Properties = "Properties",
            RowId = "RowId",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            Version = "Version",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IgnorePolicyCode = "IgnorePolicyCode",
            Notes = "Notes",
            UserTags = "UserTags",
            AssignedTo = "AssignedTo",
            AssignedBy = "AssignedBy",
            AssignedWhen = "AssignedWhen",
            ReviewedBy = "ReviewedBy",
            ReviewedWhen = "ReviewedWhen",
            IgnoredBy = "IgnoredBy",
            IgnoredWhen = "IgnoredWhen",
            IgnoredUntil = "IgnoredUntil",
            CompletedBy = "CompletedBy",
            CompletedWhen = "CompletedWhen",
            ExceptionTypeCodeDescription = "ExceptionTypeCodeDescription",
            ExceptionTypeCodeRowId = "ExceptionTypeCodeRowId",
            SeverityCodeSeverityLevel = "SeverityCodeSeverityLevel",
            SeverityCodeRowId = "SeverityCodeRowId",
            ExceptionLinks = "ExceptionLinks"
        }
    }
}
